import { IAppsOverviewStateService } from "./i-apps-overview-state-service";
import { InjectionToken } from "@angular/core";

export const appsOverviewStateServiceInjectionToken: InjectionToken<IAppsOverviewStateService> = new InjectionToken<IAppsOverviewStateService>("digital-signage.user-dashboard.dashboard-web.InstalledAppsOverviewStateService");
